import { Controller } from "@hotwired/stimulus"
import { showFlash } from "./flash_controller"

export default class extends Controller {
  static targets = ["form", "submitButton"]

  connect() {
    this.boundValidateForm = this.validateForm.bind(this)
    this.formTarget.addEventListener('input', this.boundValidateForm)
  }

  disconnect() {
    this.formTarget.removeEventListener('input', this.boundValidateForm)
  }

  reload() {
    window.location.reload()
  }

  validateForm() {
    const requiredFields = this.formTarget.querySelectorAll('[required]')
    let allValid = true

    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        allValid = false
        return
      }

      // Specific validation for VAT number (should be letters + numbers)
      if (field.name === 'tenant[company_vat_number]' && field.value.trim()) {
        const vatPattern = /^[A-Z]{2}[\d\w]{2,12}$/i
        if (!vatPattern.test(field.value.trim())) {
          allValid = false
        }
      }

      // Specific validation for registration number (should be numbers)
      if (field.name === 'tenant[company_registration_number]' && field.value.trim()) {
        const regPattern = /^\d+$/
        if (!regPattern.test(field.value.trim())) {
          allValid = false
        }
      }
    })

    this.submitButtonTarget.disabled = !allValid
  }

  async submit(event) {
    event.preventDefault()
    event.stopImmediatePropagation()
    
    // Manually trigger submit-protection start event
    this.formTarget.dispatchEvent(new CustomEvent('submit-protection:start'))
    
    // Find and disable submit button manually since we're preventing default
    const submitButton = this.submitButtonTarget
    const originalText = submitButton.value || submitButton.textContent
    const originalClasses = submitButton.className
    
    submitButton.disabled = true
    submitButton.classList.add("opacity-50", "cursor-not-allowed")
    submitButton.classList.remove("cursor-pointer", "hover:bg-gray-800")
    
    // Change button text
    if (submitButton.tagName === "INPUT") {
      submitButton.value = "Išsaugoma..."
    } else {
      submitButton.textContent = "Išsaugoma..."
    }

    try {
      const formData = new FormData(this.formTarget)
      const targetUrl = '/billing/update_billing_info'
      
      const response = await fetch(targetUrl, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        },
        body: formData
      })
      
      if (response.ok) {
        const data = await response.json()
        // Redirect to billing tab specifically
        window.location.href = '/settings?section=billing'
      } else {
        const errorData = await response.json()
        throw new Error(errorData.error || 'Server error')
      }

    } catch (error) {
      console.error('Error updating billing info:', error)
      showFlash('Nepavyko atnaujinti informacijos. Bandykite dar kartą.', 'error')
      
      // Reset button on error
      submitButton.disabled = false
      submitButton.className = originalClasses
      if (submitButton.tagName === "INPUT") {
        submitButton.value = originalText
      } else {
        submitButton.textContent = originalText
      }
      
      // Trigger submit-protection end event
      this.formTarget.dispatchEvent(new CustomEvent('submit-protection:end'))
    }
  }
}
